import { useEffect } from 'react';
import ReactConfetti from 'react-confetti-boom';

const ConfettiAnimation = ({ show = true, onComplete, duration = 2000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onComplete) onComplete();
    }, duration);

    return () => {
      clearTimeout(timer);
    };
  }, [onComplete]);

  return show ? (
    <ReactConfetti mode="boom" particleCount={200} colors={['#ffffff', '#dddddd']} />
  ) : null;
};

export default ConfettiAnimation;
